import React, { createContext, useContext } from 'react';
import useAzureUrlHook from '../../../hooks/Dashboard/azure/useUrl';

export const AzureUrlContext = createContext();

export const AzureUrlProvider = ({ children }) => {
  const data = useAzureUrlHook(); // Import everything from the hook

  return (
    <AzureUrlContext.Provider value={data}>
      {children}
    </AzureUrlContext.Provider>
  );
};

export const useAzureUrl = () => useContext(AzureUrlContext);